module.exports = __webpack_public_path__ + "static/media/storage-distribution.a951ffe8.png";